import React from "react";
import { PricingCard } from "./PricingCard";
import { useScrollReveal } from "./useScrollReveal";

const PLANS = [
	{
		name: "Free",
		price: "$0",
		description: "Start organizing your comps — no credit card required",
		features: [
			"4 comp decks, 10 properties each",
			"Calculator & notes",
			"500MB storage",
			"10 AI analyses/month",
		],
		cta: "Start Free",
		ctaHref: "https://chromewebstore.google.com/",
	},
	{
		name: "Pro",
		price: "$9",
		description: "Everything you need to move fast on deals",
		features: [
			"Everything in Free, plus:",
			"Unlimited decks & properties",
			"2GB storage (upgradeable)",
			"Unlimited AI analysis",
			"Team workspaces & sharing",
			"PDF export & messaging",
		],
		highlighted: true,
		badge: "Best Value",
		cta: "Start 14-Day Free Trial",
		ctaHref: "/signup",
	},
];

export function PricingSection() {
	const ref = useScrollReveal();

	return (
		<section id="pricing" className="py-20 md:py-28" ref={ref}>
			<div className="mx-auto max-w-7xl px-6">
				<div className="scroll-reveal mb-12 text-center">
					<h2 className="text-3xl font-bold tracking-tight text-white md:text-4xl">
						Simple, transparent pricing
					</h2>
					<p className="mx-auto mt-4 max-w-xl text-lg text-zinc-400">
						Start free. Upgrade when your deal flow demands it.
					</p>
				</div>

				<div className="mx-auto grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-2">
					{PLANS.map((plan, i) => (
						<div
							key={plan.name}
							className="scroll-reveal"
							style={{ transitionDelay: `${i * 100}ms` }}
						>
							<PricingCard {...plan} />
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
